import React from "react";
import "../../StyleSheets/Loader.css";
import ECGAnimation from "./ECGAnimation";
const Loader = () => {
  return (
    <div className="loader-div">
    <ECGAnimation
               classNameWeb={"loader-ecg-container"}
               classNameMobile={"loader-ecg-container-mobile"}
             />
    </div>
  );
};

export default Loader;
